import { useRoutes } from 'react-router-dom';

// project import
import BasicRoutes from './BasicRoutes';
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, LoginRoutes, BasicRoutes]);
}
